/* eslint-disable no-empty */
import { Partner, ResponseBaseGetPartners } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const partnersApi = createApi({
  reducerPath: 'partnersApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    fetchPartners: builder.query<ResponseBaseGetPartners, number>({
      query: (request) => `partners?page=${request || 1}`,
      serializeQueryArgs: ({ endpointName }) => endpointName,
      merge: (currentCache, newItems) => {
        if (currentCache?.data) {
          if (newItems?.current_page === 1) {
            return newItems;
          } else {
            return {
              ...currentCache,
              ...newItems,
              data: [...currentCache.data, ...newItems.data],
            };
          }
        }
        return newItems;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      },
    }),
    fetchPartner: builder.query<Partner, number>({
      query: (id) => `partners/${id}`,
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  reducerPath,
  reducer,
  middleware,
  useFetchPartnersQuery,
  useLazyFetchPartnersQuery,
  useFetchPartnerQuery,
  useLazyFetchPartnerQuery,
} = partnersApi;
